import React from "react";
import { Paragraph, H4 } from "../../../Common/Typography";

const ContentStatusMessage = ({ contentStates }) => {
  const activeItem = contentStates.find(item => item.condition);

  if (!activeItem) return null;

  return (
    <div className="content-message">
      <img src={activeItem.icon} alt="status-icon" style={{width: activeItem.width, height: activeItem.height}} />
      {activeItem.title && <H4>{activeItem.title}</H4>}
      {activeItem.subtitle && <Paragraph>{activeItem.subtitle}</Paragraph>}
    </div>
  );
};

export default ContentStatusMessage;
